import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export const PortalSidebar = ({ heading, headingHref, groups, activeItemId, defaultOpenGroupId }) => (
  <nav data-testid="portal-sidebar" aria-label={heading}>
    <Link to={headingHref} data-testid="portal-sidebar-heading" className="block font-serif text-lg text-white mb-4 hover:text-cyan transition-colors">
      {heading}
    </Link>
    <Accordion type="multiple" defaultValue={defaultOpenGroupId ? [String(defaultOpenGroupId)] : []} className="space-y-1">
      {groups.map((g) => (
        <AccordionItem key={g.id} value={String(g.id)} className="border-none">
          <AccordionTrigger data-testid={`portal-sidebar-group-${g.id}`} className="text-xs uppercase tracking-wide text-white/40 font-semibold hover:no-underline hover:text-white py-2 [&>svg]:size-3.5">
            <span className="text-left">{g.label}{g.range && <span className="block font-mono text-[10px] text-white/25 mt-0.5 tracking-normal uppercase">{g.range}</span>}</span>
          </AccordionTrigger>
          <AccordionContent>
            <ul className="border-l border-white/10 ml-1">
              {g.items.map((item) => {
                const active = String(item.id) === String(activeItemId);
                return (
                  <li key={item.id}>
                    <Link
                      to={item.href}
                      data-testid={`portal-sidebar-item-${item.id}`}
                      className={`block pl-4 -ml-px py-1.5 text-sm border-l-2 transition-colors ${
                        active
                          ? 'border-cyan text-white font-medium bg-white/5'
                          : 'border-transparent text-white/50 hover:text-white hover:border-white/30'
                      }`}
                    >
                      {item.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </nav>
);
